import { render, staticRenderFns } from "./Ticketingchart.vue?vue&type=template&id=22b36c96&scoped=true&"
import script from "./Ticketingchart.vue?vue&type=script&lang=js&"
export * from "./Ticketingchart.vue?vue&type=script&lang=js&"
import style0 from "./Ticketingchart.vue?vue&type=style&index=0&id=22b36c96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b36c96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22b36c96')) {
      api.createRecord('22b36c96', component.options)
    } else {
      api.reload('22b36c96', component.options)
    }
    module.hot.accept("./Ticketingchart.vue?vue&type=template&id=22b36c96&scoped=true&", function () {
      api.rerender('22b36c96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reports/sales/Ticketingchart.vue"
export default component.exports